import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { WorkInProgressApi } from './apis/work-in-progress-api';
import { WorkInProgressApiImpl } from './apis/impls/work-in-progress-api';
import { WorkInProgressExportService } from './services/work-in-progress-export-service';
import { WorkInProgressExportServiceImpl } from './services/impls/work-in-progress-export-service';
import { WorkInProgressFtoExportService } from './services/work-in-progress-fto-export-service';
import { WorkInProgressFtoExportServiceImpl } from './services/impls/work-in-progress-fto-export-service';

/**
 * 注册 Home V2 工作中任务模块依赖。
 *
 * @param bind Inversify 绑定函数。
 */
export const workInProgressModule = (bind: interfaces.Bind) => {
    bind(WorkInProgressApi).to(WorkInProgressApiImpl);
    bind(WorkInProgressFtoExportService).to(WorkInProgressFtoExportServiceImpl);
    bind(WorkInProgressExportService).to(WorkInProgressExportServiceImpl);
};

export { default as WorkInProgress } from './components/WorkInProgress.vue';
